/**
 * 新颖性报告副标题信息请求
 */
export interface NoveltyReportSubtitleInfoRequest {
    task_id: string;
}


/**
 * 新颖性报告副标题信息响应
 * @example
 * {
 *     "creator": "",
 *     "generated_time": "1742206198213",
 *     "search_qty": 7,
 *     "comparative_qty": 7,
 *     "nearest_qty": 95,
 *     "secondary_approach_qty": 95,
 *     "title": "人形机器人腿部动力结构的多自由度驱动系统设计"
 * }
 */
export interface NoveltyReportSubtitleInfoResponse {
    /**
     * 创建者
     */
    creator: string;
    /**
     * 生成时间
     */
    generated_time: number;
    /**
     * 搜索数量
     */
    search_qty: number;
    /**
     * 对比数量
     */
    comparative_qty: number;
    /**
     * 最接近的对比文献数量
     */
    nearest_qty: number;
    /**
     * 次接近的对比文献数量
     */
    secondary_approach_qty: number;
    /**
     * 新颖性报告名称
     */
    title: string;
    /**
     * 搜索范围
     */
    search_scope: {
        en: string;
        zh: string;
        jp: string;
    };
    /**
     * 副标题
     */
    header: {
        en: string;
        zh: string;
        jp: string;
    };
}

/**
 * 新颖性报告副标题信息 API
 */
export interface FtoReportSubtitleInfoApi {
    getNoveltyReportSubtitleInfo(params: NoveltyReportSubtitleInfoRequest): Promise<NoveltyReportSubtitleInfoResponse>;
}

export const FtoReportSubtitleInfoApi = Symbol.for('FtoReportSubtitleInfoApi');
